import React from "react";
import { Link } from "react-router-dom";
import { EntryIcon } from "./PublicEntryUI";

const STEPS = [
  {
    title: "Creá tu cuenta",
    text: "Nombre, email y contraseña. Entrás al panel directamente.",
  },
  {
    title: "Dale forma a tu negocio",
    text: "Ya dentro, creá tu proyecto y personalizá tu página a tu ritmo.",
  },
  {
    title: "Sumá lo que necesites",
    text: "Activá herramientas para vender y gestionar cuando te hagan falta.",
  },
];

export default function HomeHowItWorks({
  startHref = "/registro",
  onStart,
  isAuthenticated = false,
}) {
  return (
    <section
      className="wp-home-how"
      id="como-funciona"
      tabIndex={-1}
      aria-labelledby="home-how-title"
    >
      <div className="wp-entry-container">
        <div className="wp-home-how-grid">
          <div className="wp-home-section-heading">
            <p className="wp-entry-eyebrow">CÓMO FUNCIONA</p>
            <h2 id="home-how-title">
              Primero tu cuenta.
              <br />
              Después, a tu ritmo.
            </h2>
            <p>
              Empezar no debería ser la parte difícil. No hace falta configurar
              todo hoy.
            </p>
          </div>
          <ol className="wp-home-steps">
            {STEPS.map((step, index) => (
              <li key={step.title}>
                <span className="wp-home-step-number">0{index + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="wp-home-final-cta">
          <div>
            <p className="wp-entry-eyebrow">UN BUEN LUGAR PARA EMPEZAR</p>
            <h2>Hacé espacio para lo que sigue.</h2>
            <p>Tu próxima etapa puede empezar con una cuenta gratis.</p>
          </div>
          <Link className="wp-entry-primary" to={startHref} onClick={onStart}>
            {isAuthenticated ? "Abrir mi panel" : "Crear cuenta gratis"}
            <EntryIcon size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
}
